import React from "react";
const HEXGlobe = () => {
  return (
    <svg
      aria-hidden="true"
      fill="#FFF"
      focusable="false"
      width="24"
      viewBox="0 0 24 24"
      height="24"
    >
      <path d="M12 1.25A10.75 10.75 0 1 0 22.75 12 10.76 10.76 0 0 0 12 1.25Zm9.21 10H16.7a16 16 0 0 0-3-8.34 9.27 9.27 0 0 1 7.51 8.34ZM8.8 12.75h6.4a14.56 14.56 0 0 1-3.2 8.1 14.47 14.47 0 0 1-3.2-8.1Zm0-1.5a14.56 14.56 0 0 1 3.2-8.1 14.47 14.47 0 0 1 3.2 8.1Zm1.51-8.34a16.08 16.08 0 0 0-3 8.34H2.79a9.27 9.27 0 0 1 7.52-8.34Zm-7.52 9.84H7.3a16 16 0 0 0 3 8.34 9.27 9.27 0 0 1-7.51-8.34Zm10.9 8.34a16.08 16.08 0 0 0 3-8.34h4.51a9.27 9.27 0 0 1-7.51 8.34Z"></path>
    </svg>
  );
};
export default HEXGlobe;
